export interface Images {
  30: URL;
  31: URL;
  32: URL;
  33: URL;
  34: URL;
  35: URL;
  36: URL;
  37: URL;
  38: URL;
  39: URL;
  40: URL;
  41: URL;
  42: URL;
  43: URL;
  44: URL;
  45: URL;
  46: URL;
  47: URL;
  48: URL;
  49: URL;
  50: URL;
  51: URL;
  52: URL;
  53: URL;
  54: URL;
  55: URL;
  56: URL;
  57: URL;
  58: URL;
  59: URL;
  60: URL;
  61: URL;
  62: URL;
  63: URL;
  64: URL;
  65: URL;
  66: URL;
  67: URL;
  68: URL;
  69: URL;
  70: URL;
  71: URL;
  72: URL;
  73: URL;
  74: URL;
  75: URL;
  76: URL;
  77: URL;
  78: URL;
  79: URL;
  80: URL;
  81: URL;
  82: URL;
  83: URL;
  84: URL;
  85: URL;
  86: URL;
  87: URL;
  88: URL;
  89: URL;
  90: URL;
  91: URL;
  92: URL;
  93: URL;
  94: URL;
  95: URL;
  96: URL;
  97: URL;
  98: URL;
  99: URL;
  100: URL;
  101: URL;
  102: URL;
  103: URL;
  104: URL;
  105: URL;
  106: URL;
  107: URL;
  108: URL;
  109: URL;
  110: URL;
  111: URL;
  112: URL;
  113: URL;
  114: URL;
  115: URL;
  116: URL;
  117: URL;
  118: URL;
  119: URL;
  120: URL;
  121: URL;
  122: URL;
  123: URL;
  124: URL;
  125: URL;
  126: URL;
  127: URL;
  128: URL;
  129: URL;
  130: URL;
  131: URL;
}

export const IMAGE_URLS: Images = {
  30: new URL("../img/thirty.png", import.meta.url),
  31: new URL("../img/thirty-one.png", import.meta.url),
  32: new URL("../img/thirty-two.png", import.meta.url),
  33: new URL("../img/thirty-three.png", import.meta.url),
  34: new URL("../img/thirty-four.png", import.meta.url),
  35: new URL("../img/thirty-five.png", import.meta.url),
  36: new URL("../img/thirty-six.png", import.meta.url),
  37: new URL("../img/thirty-seven.png", import.meta.url),
  38: new URL("../img/thirty-eight.png", import.meta.url),
  39: new URL("../img/thirty-nine.png", import.meta.url),
  40: new URL("../img/forty.png", import.meta.url),
  41: new URL("../img/forty-one.png", import.meta.url),
  42: new URL("../img/forty-two.png", import.meta.url),
  43: new URL("../img/forty-three.png", import.meta.url),
  44: new URL("../img/forty-four.png", import.meta.url),
  45: new URL("../img/forty-five.png", import.meta.url),
  46: new URL("../img/forty-six.png", import.meta.url),
  47: new URL("../img/forty-seven.png", import.meta.url),
  48: new URL("../img/forty-eight.png", import.meta.url),
  49: new URL("../img/forty-nine.png", import.meta.url),
  50: new URL("../img/fifty.png", import.meta.url),
  51: new URL("../img/fifty-one.png", import.meta.url),
  52: new URL("../img/fifty-two.png", import.meta.url),
  53: new URL("../img/fifty-three.png", import.meta.url),
  54: new URL("../img/fifty-four.png", import.meta.url),
  55: new URL("../img/fifty-five.png", import.meta.url),
  56: new URL("../img/fifty-six.png", import.meta.url),
  57: new URL("../img/fifty-seven.png", import.meta.url),
  58: new URL("../img/fifty-eight.png", import.meta.url),
  59: new URL("../img/fifty-nine.png", import.meta.url),
  60: new URL("../img/sixty.png", import.meta.url),
  61: new URL("../img/sixty-one.png", import.meta.url),
  62: new URL("../img/sixty-two.png", import.meta.url),
  63: new URL("../img/sixty-three.png", import.meta.url),
  64: new URL("../img/sixty-four.png", import.meta.url),
  65: new URL("../img/sixty-five.png", import.meta.url),
  66: new URL("../img/sixty-six.png", import.meta.url),
  67: new URL("../img/sixty-seven.png", import.meta.url),
  68: new URL("../img/sixty-eight.png", import.meta.url),
  69: new URL("../img/sixty-nine.png", import.meta.url),
  70: new URL("../img/seventy.png", import.meta.url),
  71: new URL("../img/seventy-one.png", import.meta.url),
  72: new URL("../img/seventy-two.png", import.meta.url),
  73: new URL("../img/seventy-three.png", import.meta.url),
  74: new URL("../img/seventy-four.png", import.meta.url),
  75: new URL("../img/seventy-five.png", import.meta.url),
  76: new URL("../img/seventy-six.png", import.meta.url),
  77: new URL("../img/seventy-seven.png", import.meta.url),
  78: new URL("../img/seventy-eight.png", import.meta.url),
  79: new URL("../img/seventy-nine.png", import.meta.url),
  80: new URL("../img/eighty.png", import.meta.url),
  81: new URL("../img/eighty-one.png", import.meta.url),
  82: new URL("../img/eighty-two.png", import.meta.url),
  83: new URL("../img/eighty-three.png", import.meta.url),
  84: new URL("../img/eighty-four.png", import.meta.url),
  85: new URL("../img/eighty-five.png", import.meta.url),
  86: new URL("../img/eighty-six.png", import.meta.url),
  87: new URL("../img/eighty-seven.png", import.meta.url),
  88: new URL("../img/eighty-eight.png", import.meta.url),
  89: new URL("../img/eighty-nine.png", import.meta.url),
  90: new URL("../img/ninety.png", import.meta.url),
  91: new URL("../img/ninety-one.png", import.meta.url),
  92: new URL("../img/ninety-two.png", import.meta.url),
  93: new URL("../img/ninety-three.png", import.meta.url),
  94: new URL("../img/ninety-four.png", import.meta.url),
  95: new URL("../img/ninety-five.png", import.meta.url),
  96: new URL("../img/ninety-six.png", import.meta.url),
  97: new URL("../img/ninety-seven.png", import.meta.url),
  98: new URL("../img/ninety-eight.png", import.meta.url),
  99: new URL("../img/ninety-nine.png", import.meta.url),
  100: new URL("../img/hundred.png", import.meta.url),
  101: new URL("../img/hundred-one.png", import.meta.url),
  102: new URL("../img/hundred-two.png", import.meta.url),
  103: new URL("../img/hundred-three.png", import.meta.url),
  104: new URL("../img/hundred-four.png", import.meta.url),
  105: new URL("../img/hundred-five.png", import.meta.url),
  106: new URL("../img/hundred-six.png", import.meta.url),
  107: new URL("../img/hundred-seven.png", import.meta.url),
  108: new URL("../img/hundred-eight.png", import.meta.url),
  109: new URL("../img/hundred-nine.png", import.meta.url),
  110: new URL("../img/hundred-ten.png", import.meta.url),
  111: new URL("../img/hundred-eleven.png", import.meta.url),
  112: new URL("../img/hundred-twelve.png", import.meta.url),
  113: new URL("../img/hundred-thirteen.png", import.meta.url),
  114: new URL("../img/hundred-fourteen.png", import.meta.url),
  115: new URL("../img/hundred-fifteen.png", import.meta.url),
  116: new URL("../img/hundred-sixteen.png", import.meta.url),
  117: new URL("../img/hundred-seventeen.png", import.meta.url),
  118: new URL("../img/hundred-eighteen.png", import.meta.url),
  119: new URL("../img/hundred-nineteen.png", import.meta.url),
  120: new URL("../img/hundred-twenty.png", import.meta.url),
  121: new URL("../img/hundred-twenty-one.png", import.meta.url),
  122: new URL("../img/hundred-twenty-two.png", import.meta.url),
  123: new URL("../img/hundred-twenty-three.png", import.meta.url),
  124: new URL("../img/hundred-twenty-four.png", import.meta.url),
  125: new URL("../img/hundred-twenty-five.png", import.meta.url),
  126: new URL("../img/hundred-twenty-six.png", import.meta.url),
  127: new URL("../img/hundred-twenty-seven.png", import.meta.url),
  128: new URL("../img/hundred-twenty-eight.png", import.meta.url),
  129: new URL("../img/hundred-twenty-nine.png", import.meta.url),
  130: new URL("../img/hundred-thirty.png", import.meta.url),
  131: new URL("../img/hundred-thirty-one.png", import.meta.url),
}